<template>
  <div class="list_contnet">
    <div class="box">
      <div class="nav">{{ nav }}</div>
      <div class="title">{{ title }}</div>
      <div class="time">你当前案件累计工时：{{ time }}人月</div>
    </div>
    <van-icon color="#a0a0a0" size="16" name="arrow" />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { Icon } from 'vant';

export default defineComponent({
  props: {
    nav: {
      type: String,
    },
    title: {
      type: String,
    },
    time: {
      type: Number,
    },
  },
  components: {
    [Icon.name]: Icon,
  },
  setup(props) {
    console.log(props);
  },
});
</script>
<style lang="scss" scoped>
.list_contnet {
  border-radius: 10px;
  background: #fff;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  .box {
    width: calc(100% - 40px);
    .nav {
      font-size: 12px;
      color: #9c9c9c;
    }
    .title {
      font-size: 19px;
      font-weight: bold;
      color: #727272;
      margin-top: 5px;
      white-space: nowrap;
      text-overflow:ellipsis;
      overflow: hidden;
    }
    .time {
      font-size: 12px;
      color: #9c9c9c;
      margin-top: 10px;
    }
  }
}
</style>
